// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"ad8f0ac5","290":"0a48be8c","346":"21a446da","359":"cc310ade","579":"95d6d636","740":"585e1933"}[chunkId] + ".chunk.css";
};